export default "__VITE_ASSET__3e47ad83__"